import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
let ViedocInactivityTracker = class ViedocInactivityTracker extends LitElement {
    constructor() {
        super(...arguments);
        this.postLogoutUri = '';
        this.heartBeatUrl = '';
        this.origin = '';
        this.hotReload = false;
        this.isSinglePage = false;
        this.keepAlive = false;
        this.userActivityTrackingIntervalTime = 2 * 1000; // 2 seconds
        this.isUserActive = false;
        this.lastClientX = 0;
        this.lastClientY = 0;
        this.autoLogoutUrlParam = 'isAutoLogout=true';
    }
    connectedCallback() {
        super.connectedCallback();
        this.initInactivityTimeoutFeature();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.clearInactivityTimeoutFeature();
    }
    updated() {
        if (this.keepAlive) {
            if (!this.keepUserActiveInterval) {
                this.keepUserActiveInterval = window.setInterval(() => {
                    this.postMessageUserActivity();
                }, this.userActivityTrackingIntervalTime);
            }
        }
        else {
            window.clearInterval(this.keepUserActiveInterval);
            this.keepUserActiveInterval = undefined;
        }
    }
    postMessageUserActivity() {
        var _a, _b;
        (_b = (_a = this.heartbeatIframe) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage({
            message: 'user-activity',
            lastActiveTick: new Date().getTime(),
        }, '*');
    }
    render() {
        const src = `${this.heartBeatUrl}?origin=${this.origin}`;
        return html ` <iframe
      src="${src}"
      name="viedoc-inactivity-tracker"
      class="inactivity-tracker__hidden"
      title="viedoc.idp"
    >
    </iframe>`;
    }
    initInactivityTimeoutFeature() {
        if (!this.userActivityTrackingInterval) {
            this.userActivityTrackingInterval = window.setInterval(() => this.trackUserActivity(), this.userActivityTrackingIntervalTime);
        }
        window.addEventListener('mousemove', e => this.onMouseMove(e));
        window.addEventListener('touchstart', () => this.updateWhenUserActive());
        window.addEventListener('tap', () => this.updateWhenUserActive());
        window.addEventListener('click', () => this.updateWhenUserActive());
        window.addEventListener('keydown', () => this.updateWhenUserActive());
        window.addEventListener('message', e => this.onReceivePostMessage(e));
    }
    clearInactivityTimeoutFeature() {
        window.clearInterval(this.userActivityTrackingInterval);
        window.clearInterval(this.keepUserActiveInterval);
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('touchstart', this.updateWhenUserActive);
        window.removeEventListener('tap', this.updateWhenUserActive);
        window.removeEventListener('click', this.updateWhenUserActive);
        window.removeEventListener('keydown', this.updateWhenUserActive);
        window.removeEventListener('message', this.onReceivePostMessage);
    }
    trackUserActivity() {
        if (this.isUserActive) {
            this.postMessageUserActivity();
            // Reset until user's next action
            this.isUserActive = false;
        }
    }
    onMouseMove(e) {
        if (this.lastClientX !== e.clientX || this.lastClientY !== e.clientY) {
            // because webkit keeps on firing the event if cursor is in page
            this.updateWhenUserActive();
        }
        this.lastClientX = e.clientX;
        this.lastClientY = e.clientY;
    }
    onReceivePostMessage(e) {
        if (!e.data)
            return;
        if (e.data === 'direct-inactivity-logout') {
            this.inactivityLogOut();
        }
        if (this.hotReload) {
            if (e.data === 'inactivity-logout') {
                this.inactivityLogOut();
            }
            // case session is expired during signing
            if (e.data === 'session-expired') {
                this.logout();
            }
            if (e.data === 'user-logout') {
                this.logout();
            }
        }
    }
    inactivityLogOut() {
        if (!this.postLogoutUri) {
            return;
        }
        this.clearInactivityTimeoutFeature();
        const urlParamAppender = this.postLogoutUri.indexOf('?') > 0 ? '&' : '?';
        const logoutUri = `${this.postLogoutUri}${urlParamAppender}${this.autoLogoutUrlParam}`;
        window.location = logoutUri;
    }
    logout() {
        const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
        if (!isFirefox || this.isSinglePage) {
            window.location.href = this.postLogoutUri;
        }
        else {
            fetch(this.postLogoutUri).then(response => {
                if (response.ok)
                    window.location.reload();
            });
        }
    }
    updateWhenUserActive() {
        if (this.isUserActive) {
            return;
        }
        this.isUserActive = true;
    }
};
ViedocInactivityTracker.styles = [
    css `
      .inactivity-tracker__hidden {
        display: none;
      }
    `,
];
__decorate([
    property({ type: String, attribute: 'post-logout-uri' })
], ViedocInactivityTracker.prototype, "postLogoutUri", void 0);
__decorate([
    property({ type: String, attribute: 'heartbeat-url' })
], ViedocInactivityTracker.prototype, "heartBeatUrl", void 0);
__decorate([
    property({ type: String, attribute: 'origin' })
], ViedocInactivityTracker.prototype, "origin", void 0);
__decorate([
    property({ type: Boolean, attribute: 'hot-reload' })
], ViedocInactivityTracker.prototype, "hotReload", void 0);
__decorate([
    property({ type: Boolean, attribute: 'is-single-page' })
], ViedocInactivityTracker.prototype, "isSinglePage", void 0);
__decorate([
    property({ type: Boolean, attribute: 'keep-alive' })
], ViedocInactivityTracker.prototype, "keepAlive", void 0);
__decorate([
    property({ type: Number, attribute: 'user-activity-tracking-interval' })
], ViedocInactivityTracker.prototype, "userActivityTrackingIntervalTime", void 0);
__decorate([
    query('iframe[name="viedoc-inactivity-tracker"]')
], ViedocInactivityTracker.prototype, "heartbeatIframe", void 0);
ViedocInactivityTracker = __decorate([
    customElement('viedoc-inactivity-tracker')
], ViedocInactivityTracker);
export { ViedocInactivityTracker };
